"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationService = void 0;
const tslib_1 = require("tslib");
const __1 = require("..");
/**
 * A context service to get/set the active notification message
 */
let NotificationService = class NotificationService {
    constructor() {
        this.activeMessages = new __1.ObservableValue([]);
    }
    add(newMessage) {
        this.activeMessages.setValue([
            ...this.activeMessages.getValue().filter((message) => message.level !== newMessage.level),
            newMessage,
        ]);
    }
    dismiss(oldItem) {
        this.activeMessages.setValue([...this.activeMessages.getValue()].filter((message) => message && JSON.stringify(message) !== JSON.stringify(oldItem)));
    }
};
NotificationService = tslib_1.__decorate([
    __1.Injectable({ lifetime: 'singleton' })
], NotificationService);
exports.NotificationService = NotificationService;
//# sourceMappingURL=notification-service.js.map